// ─── Types ──────────────────────────────────────────────────────────
// ─── Initial State ──────────────────────────────────────────────────
export const initialAuthState = {
    user: null,
    accessToken: null,
    refreshToken: null,
    isLoading: false,
    error: null,
    isAuthenticated: false,
};
// ─── Actions ────────────────────────────────────────────────────────
export function setAuthLoading(state) {
    return { ...state, isLoading: true, error: null };
}
export function setLoginSuccess(state, user, accessToken, refreshToken) {
    return {
        ...state,
        user,
        accessToken,
        refreshToken,
        isLoading: false,
        error: null,
        isAuthenticated: true,
    };
}
export function setTokenRefreshed(state, accessToken, refreshToken) {
    return { ...state, accessToken, refreshToken, isLoading: false, isAuthenticated: true };
}
export function setAuthError(state, error) {
    return { ...state, isLoading: false, error };
}
export function setLogout() {
    return { ...initialAuthState };
}
export function updateUser(state, updates) {
    if (!state.user)
        return state;
    return { ...state, user: { ...state.user, ...updates } };
}
export function clearAuthError(state) {
    return { ...state, error: null };
}
//# sourceMappingURL=authStore.js.map